import lodashGet from "lodash/get";

import { ENDPOINT_POWER_OUTAGE } from "@/common/constants/api";
import { httpGet } from "@/services/api.service";
import { encodeAllURLParameters } from "@/common/api.utilities";
import { query } from "vue-analytics";
import { MODULE_PREFIX_USER } from "@/store";
import lodashCloneDeep from "lodash/cloneDeep";
import { SAVE_PREFERENCES } from "@/store/actions.type";

export { _getCounty as getCounty };
export { _getPreference as getPreference };
export { _savePreference as savePreference };

const _getCounty = async (params) => {
  try {
    if (lodashGet(params, "fips") && lodashGet(params, "type")) {
      const fips = params.fips;
      const type = params.type;

      const RESULT = await httpGet({
        url: `${ENDPOINT_POWER_OUTAGE}/${fips}?type=${type}`,
        noCache: true,
      });

      const { data } = JSON.parse(RESULT);

      if (data) {
        return {
          feature: data,
          title: "POWER OUTAGE EVENT",
        };
      }
      return false;
    }
    return false;
  } catch (error) {
    console.error("Unable to get county data: ", JSON.stringify(error));
    return false;
  }
};

const _getPreference = (store, defaultValue, property, type) => {
  let preferences = store.getters[MODULE_PREFIX_USER + "preferences"];

  //if preference hasn't been set default value
  const propertyString = type;
  if (
    !(
      lodashGet(preferences, propertyString) &&
      preferences.powerOutage.hasOwnProperty(property)
    )
  ) {
    _savePreference(store, defaultValue, property, type);
  }

  if (
    lodashGet(preferences, propertyString) &&
    preferences.powerOutage.hasOwnProperty(property)
  ) {
    return preferences[type][property];
  }
  return null;
};

const _savePreference = (store, value, property, type) => {
  type = type ? type : "powerOutage";

  let preferences = lodashCloneDeep(
    store.getters[MODULE_PREFIX_USER + "preferences"]
  );
  preferences = preferences || {};
  preferences[type] = preferences[type] || {};

  let last = preferences;
  // This if statement captures nested properties, like "stability.enabled" for the property value
  if (property.includes(".")) {
    const split = property.split(".");
    split.unshift(type); // This will be an array, such as ["grids", "stability", "enabled"]
    for (let i = 0; i < split.length - 1; i++) {
      const cur = split[i];
      if (last.hasOwnProperty(cur)) {
        if (i === split.length - 2) {
          last[cur][split[i + 1]] = value;
        } else {
          last = last[cur];
        }
      } else {
        last[cur] = {};
        if (i === split.length - 2) {
          last[cur][split[i + 1]] = value;
        } else {
          last = last[cur];
        }
      }
    }
  } else {
    preferences[type][property] = value;
  }

  store.dispatch(MODULE_PREFIX_USER + SAVE_PREFERENCES, preferences);
};
